module.exports = __webpack_public_path__ + "img/TipperRoof_Overview-Middle_1.3911ff6b.jpg";